// extracted by mini-css-extract-plugin
export default {"subContainer":"ExceptionsArea_subContainer__J+9th","header":"ExceptionsArea_header__LOd9k","msgArea":"ExceptionsArea_msgArea__uFHmW"};